/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Profile_TitleInputs */

const en_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Profile`)
};

const fr_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le profil`)
};

const de_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil auswählen`)
};

const it_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona profilo`)
};

const ru_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите профиль`)
};

const es_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar perfil`)
};

const zh_cn2_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择个人资料`)
};

const ja_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールを選択`)
};

const hi_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल चुनें`)
};

const pt_pt2_editor_select_profile_title = /** @type {(inputs: Editor_Select_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar perfil`)
};

/**
* | output |
* | --- |
* | "Select Profile" |
*
* @param {Editor_Select_Profile_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_profile_title = /** @type {((inputs?: Editor_Select_Profile_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Profile_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_select_profile_title(inputs)
	if (locale === "de") return de_editor_select_profile_title(inputs)
	if (locale === "it") return it_editor_select_profile_title(inputs)
	if (locale === "ru") return ru_editor_select_profile_title(inputs)
	if (locale === "es") return es_editor_select_profile_title(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_select_profile_title(inputs)
	if (locale === "ja") return ja_editor_select_profile_title(inputs)
	if (locale === "hi") return hi_editor_select_profile_title(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_select_profile_title(inputs)
	return en_editor_select_profile_title(inputs)
});